<div class="bar">
  <div class="progress" [style.width.%]="vm.percentage"></div>
</div>

<section class="flex full-width mt-8">
  <p class="body bold">You're {{ vm.percentage }}% done</p>
  <button class="ml-auto link-text large" (click)="showBookingStep.emit()">See booking steps</button>
</section>
